import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import store from './app/store/index'
import Layout from '@/app/components/Layout/Layout'
import SimuladorService from '@/app/services/Simulador/simulador.service'

const Erro = () => import(/* webpackChunkName: "geral-bundle" */ '@/app/views/Erro.vue');
const Principal = () => import(/* webpackChunkName: "geral-bundle" */ '@/app/views/Principal.vue');
const Relatorio = () => import(/* webpackChunkName: "geral-bundle" */ '@/app/views/Relatorio.vue');

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        { path: '/', redirect: 'principal' },
        { path: '/erro', name: 'Erro', component: Erro, meta: { allow: 'everyone' }},
        { path: '/', component: Layout, children: [
            { path: '/principal', name: 'Principal', component: Principal, async beforeEnter(to, from, next) {
                if (!to.query.token) { // Não existe token na url. Gerar um e inseri-lo na url
                    let resposta = await SimuladorService.obterTokenCarteira();

                    if (resposta.sucesso) {
                        store.commit("setCarteiraAtualSalva", false);
                        router.push({ path: 'principal', query: { token: resposta.token }})
                        // next();
                    }
                } else { // Token foi informado, verificar se ele é válido
                    let resposta = await SimuladorService.validarTokenCarteira(to.query.token);

                    if (resposta.sucesso) {
                        next();
                    } else { // Token inválido; gerar outro
                        resposta = await SimuladorService.obterTokenCarteira();
                        
                        if (resposta.sucesso) {
                            store.commit("setCarteiraAtualSalva", false);
                            router.push({ path: 'principal', query: { token: resposta.token }})
                            // next();
                        }
                    }
                }
            } },
            { path: '/relatorio', component: Relatorio },
        ]}
    ]
})

router.afterEach((to) => {
    document.title = "Simulador de investimentos | smartbrain";
});

export default router;